import { render, staticRenderFns } from "./AddSeniorBill.vue?vue&type=template&id=24039e8e&scoped=true"
import script from "./AddSeniorBill.vue?vue&type=script&lang=js"
export * from "./AddSeniorBill.vue?vue&type=script&lang=js"
import style0 from "./AddSeniorBill.vue?vue&type=style&index=0&id=24039e8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24039e8e",
  null
  
)

export default component.exports